import { LdTypo } from "@emdgroup-liquid/liquid/dist/react";
import styled from "@emotion/styled";
import { pxToRem } from "@src/utils";

export const StyledBarChart = styled.div`
  padding: ${pxToRem(24)};
`;
export const StyledImgCard = styled.div`
  padding: ${pxToRem(24)};
  display: flex;
`;
export const StyledBarChartLabel = styled(LdTypo)`
  color: var(--ld-thm-primary);
  text-align: center;
  padding: 0;
`;
export const StyledImgCardLabel = styled(LdTypo)`
  color: var(--ld-col-neutral-400);
  padding-bottom: ${pxToRem(4)};
`;
